module.exports = __webpack_public_path__ + "static/media/42.fcf3f9c6.png";